import api from "../Component/axios";

export const useUserCampo = () => {
  const token = localStorage.getItem("@Token");
  const user = localStorage.getItem("@usuario");
  const json_user = JSON.parse(user);

  const getCampos = async () => {
    try {
      const response = await api.get(
        `api/permisos/get/campos-user/?id_usuario=${json_user.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  return { getCampos };
};
